// extracted by mini-css-extract-plugin
export default {"fullWidth":"Fo-z","image":"Go-z","lazyLoadPicture":"Ho-z","lazyLoadSpinner":"Io-z","lazyLoadSpin":"Jo-z","lazyLoadImage":"Ko-z","hasStyledAspectRatio":"Lo-z"};